import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initGA } from "./lib/gtag";

// Load GA4 on boot (US-based, analytics granted by default via Consent Mode v2)
initGA();

createRoot(document.getElementById("root")!).render(<App />);
